import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["draggable", "onClick", "onDragstart", "onDrop"]
const _hoisted_4 = { key: 0 }

import DocumentMedia from "@/components/media/document.vue"
  import ImageMedia from "@/components/media/image.vue"
  import VideoMedia from "@/components/media/video.vue"
  import ContentModal from "@/components/modals/content.vue"
  import FileInput from "@/components/inputs/file.vue"
  import Button from "@/components/button.vue"
  import {File} from "@/endpoints/rutsolve/gql/generated/graphql"
  import {nextTick, ref, useTemplateRef} from "vue"
  import Enumeration from "@/components/selectors/enumeration.vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'file',
  props: /*@__PURE__*/_mergeModels({
    readOnly: {
      default: false,
      required: false,
      type: Boolean
    }
  }, {
    "items": {
    default: null,
    required: true,
    type: Array<File>
  },
    "itemsModifiers": {},
    "selectedIndex": {
    default: null,
    required: false,
    type: Number
  },
    "selectedIndexModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["select"], ["update:items", "update:selectedIndex"]),
  setup(__props, { emit: __emit }) {

  

  const emits = __emit

  const items = _useModel(__props, "items")
  
  const selectedIndex = _useModel(__props, "selectedIndex")

  const fileInput = useTemplateRef("fileInput")

  const displayAdd = ref<boolean>(null)
  const selectedType = ref<string>(null)

  async function select(index: number) {
    selectedIndex.value = index
    await nextTick()
    emits("select")
  }

  function dragStart(event: DragEvent, index: number) {
    event.dataTransfer.dropEffect = "move"
    event.dataTransfer.effectAllowed = "move"
    event.dataTransfer.setData("INDEX", index.toString())
  }

  function drop(event: DragEvent, index: number) {
    const startIndex = parseInt(event.dataTransfer.getData("INDEX"))
    items.value.splice(index, 0, items.value.splice(startIndex, 1)[0])
    updatePriority()
  }

  function updatePriority() {
    for (const [index, file] of items.value.entries()) {
      file.priority = index
    }
  }

  function remove(event: MouseEvent, index: number) {
    event.stopPropagation()
    items.value[index].deletedAt = new Date().toISOString()
  }

  function add() {
    for (const file of fileInput.value.files) {
      items.value.push({
        data: file.data,
        extension: file.extension,
        name: file.name,
        type: selectedType.value
      })
    }
    updatePriority()
    displayAdd.value = false
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _createElementVNode("table", null, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (!__props.readOnly)
              ? (_openBlock(), _createElementBlock("th", _hoisted_1, [
                  _createVNode(Button, {
                    title: "Add",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (displayAdd.value = true))
                  })
                ]))
              : _createCommentVNode("", true),
            _cache[6] || (_cache[6] = _createElementVNode("th", null, " Preview ", -1)),
            _cache[7] || (_cache[7] = _createElementVNode("th", null, " Type ", -1)),
            _cache[8] || (_cache[8] = _createElementVNode("th", null, " Name ", -1)),
            _cache[9] || (_cache[9] = _createElementVNode("th", null, " Extension ", -1)),
            _cache[10] || (_cache[10] = _createElementVNode("th", null, " Description ", -1))
          ])
        ]),
        (items.value.length > 0)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (file, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: file.name + file.extension
                }, [
                  (!file.deletedAt)
                    ? (_openBlock(), _createElementBlock("tr", {
                        key: 0,
                        draggable: !__props.readOnly,
                        onClick: ($event: any) => (select(index)),
                        onDragstart: ($event: any) => (dragStart($event, index)),
                        onDrop: ($event: any) => (drop($event, index)),
                        onDragenter: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                        onDragover: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
                      }, [
                        (!__props.readOnly)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_4, [
                              _createVNode(Button, {
                                title: "Remove",
                                onClick: ($event: any) => (remove($event, index))
                              }, null, 8, ["onClick"])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", null, [
                          (file.type == 'DOCUMENT')
                            ? (_openBlock(), _createBlock(DocumentMedia, {
                                key: 0,
                                data: file.data,
                                extension: file.extension,
                                title: file.name,
                                url: file.url
                              }, null, 8, ["data", "extension", "title", "url"]))
                            : _createCommentVNode("", true),
                          (file.type == 'PICTURE')
                            ? (_openBlock(), _createBlock(ImageMedia, {
                                key: 1,
                                data: file.data,
                                extension: file.extension,
                                title: file.name,
                                url: file.url
                              }, null, 8, ["data", "extension", "title", "url"]))
                            : _createCommentVNode("", true),
                          (file.type == 'VIDEO')
                            ? (_openBlock(), _createBlock(VideoMedia, {
                                key: 2,
                                data: file.data,
                                extension: file.extension,
                                title: file.name,
                                url: file.url
                              }, null, 8, ["data", "extension", "title", "url"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(file.type), 1),
                        _createElementVNode("td", null, _toDisplayString(file.name), 1),
                        _createElementVNode("td", null, _toDisplayString(file.extension), 1),
                        _createElementVNode("td", null, _toDisplayString(file.description), 1)
                      ], 40, _hoisted_3))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      (displayAdd.value)
        ? (_openBlock(), _createBlock(ContentModal, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(Enumeration, {
                selection: selectedType.value,
                "onUpdate:selection": _cache[3] || (_cache[3] = ($event: any) => ((selectedType).value = $event)),
                title: "Type",
                options: ['DOCUMENT', 'PICTURE', 'VIDEO']
              }, null, 8, ["selection"]),
              (!__props.readOnly)
                ? (_openBlock(), _createBlock(FileInput, {
                    key: 0,
                    ref_key: "fileInput",
                    ref: fileInput,
                    title: "Add",
                    multiple: "",
                    onUpdate: _cache[4] || (_cache[4] = ($event: any) => (add()))
                  }, null, 512))
                : _createCommentVNode("", true),
              _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
              _createVNode(Button, {
                title: "Close",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (displayAdd.value = false))
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})